/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ trial: NonNullable<unknown> }} Terms_Plans_1Inputs */

const da_terms_plans_1 = /** @type {(inputs: Terms_Plans_1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du starter med ${i?.trial} gratis credits (planen Prøv). Priserne for Lærer (pr. måned eller pr. år), Skole (pr. elev pr. år) og pakker med ekstra besvarelser står under Indstillinger → Abonnement, før du betaler.`)
};

/** @type {(inputs: Terms_Plans_1Inputs) => LocalizedString} */
const en_terms_plans_1 = da_terms_plans_1;

/**

* @param {Terms_Plans_1Inputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const terms_plans_1 = /** @type {((inputs: Terms_Plans_1Inputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Plans_1Inputs, { locale?: "da" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_plans_1(inputs)
	return da_terms_plans_1(inputs)
});